module.exports = __webpack_public_path__ + "media/images/white-99f5bde00f23b1b39f6d4683eb98d492.png";